/**
 * Copyright (C) Mairistem
 *
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 *
 * Proprietary and confidential
 */

import {
  OPTIONS_ATTESTATION_LIEN_PARENTE,
  OPTIONS_AIDE_MATERIELLE,
  OPTIONS_REGIME_BIEN,
  OPTIONS_TYPE_COMPARUTION,
  OPTIONS_TYPE_CONVENTION_FICHE,
} from '@/constants';

import resolveCasCode from './resolveCasCode';

/**
 * Convertit tous les champs codés d'une convention (libellé, tel que renvoyé
 * par le GET) en clé numérique (attendue par le PUT).
 *
 * Chaque modale d'édition ne convertit que les champs codés qu'elle édite
 * elle-même (dans son brouillon) ; comme la sauvegarde ré-envoie toujours la
 * convention complète (`{ ...conventionDeclaration, ...draft }`), les champs
 * codés non touchés par la modale ouverte resteraient sinon au libellé du GET
 * et seraient rejetés par le backend (qui n'attend que la clé). On normalise
 * donc systématiquement la convention de base avant de fusionner le brouillon
 * par-dessus.
 */
const normalizeConventionCodes = (conventionDeclaration: any) => ({
  ...conventionDeclaration,
  typeConvention: resolveCasCode(
    OPTIONS_TYPE_CONVENTION_FICHE,
    conventionDeclaration?.typeConvention,
  ),
  aideMaterielle: resolveCasCode(
    OPTIONS_AIDE_MATERIELLE,
    conventionDeclaration?.aideMaterielle,
  ),
  regimeBien: resolveCasCode(
    OPTIONS_REGIME_BIEN,
    conventionDeclaration?.regimeBien,
  ),
  attestationLienParente: resolveCasCode(
    OPTIONS_ATTESTATION_LIEN_PARENTE,
    conventionDeclaration?.attestationLienParente,
  ),
  typeComparution: resolveCasCode(
    OPTIONS_TYPE_COMPARUTION,
    conventionDeclaration?.typeComparution,
  ),
});

export default normalizeConventionCodes;
